"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Logger_1 = require("./Logger");
var ConsoleLoggerSingleton = /** @class */ (function () {
    function ConsoleLoggerSingleton(mode) {
        this.mode = mode;
    }
    ConsoleLoggerSingleton.prototype.log = function () {
        var messages = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            messages[_i] = arguments[_i];
        }
        switch (this.mode) {
            case Logger_1.LogLevel.DEBUG:
                console.log.apply(console, messages);
                break;
            case Logger_1.LogLevel.TRACE:
                console.trace.apply(console, messages);
                break;
            default:
        }
    };
    return ConsoleLoggerSingleton;
}());
exports.ConsoleLogger = new ConsoleLoggerSingleton(Logger_1.LogLevel.NONE);
//# sourceMappingURL=ConsoleLogger.js.map